module.exports = __webpack_public_path__ + "img/img_h_1.218e30bd.jpg";